<template>
  <a-drawer
    :maskClosable="false"
    width="60%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <User :isTree="false" @backCange="backCange" :isTreeUser="true"></User>
  </a-drawer>
</template>
  <script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import COS from 'cos-js-sdk-v5'
import moment from 'moment'
import { ossSignature } from '@/api/system/user'
import { getObj, addObj, putObj } from '@/api/pressure/version'
import User from '../../system/user/index.vue'
export default {
  name: 'CreateForm',
  components: { User },
  data() {
    return {
      submitLoading: false,
      isUploading: false,
      formTitle: '',
      open: false,
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
  },
  computed: {
    ...mapGetters(['userTentant', 'infoUser']),
  },
  watch: {},
  methods: {
    onClose() {
      const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    backCange(e) {
      this.open = false
      this.$emit('backCange', e)
    },
    // 取消按钮
    cancel() {
     this.onClose()
      this.reset()
    },
    // 表单重置
    reset() {},
    init() {
      this.formTitle = '选择用户'
      this.open = true
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '版本升级'
    },
    // 获取文件名称
    generateCosKey(name, ext) {
      var ymd = moment().format('YYYYMMDD')
      var ymd = moment().format('YYYYMMDD_HHmmss_')
      var r = ('000000' + Math.random() * 1000000).slice(-6)
      var cosKey = name + `/file_${ymd}_${r}.${ext}`
      return cosKey
    },
    customRequest(options) {
      const that = this
      this.isUploading = true
      const { file, onProgress, onSuccess, onError } = options
      this.fileList = [file] // 仅保留最新的一个文件
      console.log(file, onProgress, onSuccess, onError, 'file, onProgress, onSuccess, onError')
      console.log(file.name, '对对对对对对')
      var lastIndex = file.name.lastIndexOf('.')
      console.log('选择的图片路径fileName', lastIndex)
      var extName = lastIndex > -1 ? file.name.slice(lastIndex + 1) : ''
      console.log(extName, 'extNameextNameextName')
      const cosKey = this.generateCosKey(this.$cosUrl, extName)
      const fileNames = cosKey.split('/').pop()
      ossSignature().then((res) => {
        res = res.data
        const cos = new COS({
          SecretId: res.tmpSecretId,
          SecretKey: res.tmpSecretKey,
          SecurityToken: res.sessionToken, // sts服务下发的临时 SessionToken
          StartTime: res.startTime, // 建议传入服务端时间，可避免客户端时间不准导致的签名错误
          ExpiredTime: res.expiredTime, // 临时密钥过期时间
        })
        cos.putObject(
          {
            Bucket: 'hoy-1308702491', // 对象存储桶名称
            Region: 'ap-beijing', // 地域
            Key: cosKey, // 文件路径
            Body: file, // 文件对象
            Headers: {
              // 通过 imageMogr2 接口进行 jpg 压缩
              'Pic-Operations': JSON.stringify({
                is_pic_info: 1, // 返回图片信息
                rules: [
                  {
                    fileid: fileNames, // 压缩后的文件名
                    rule: 'imageMogr2/quality/33', // 启用极智压缩
                  },
                ],
              }),
            },
            SliceSize:
              1024 * 1024 * 5 /* 触发分块上传的阈值，超过5MB使用分块上传，小于5MB使用简单上传。可自行设置，非必须 */,
            onProgress: function (progressData) {},
          },
          function (err, data) {
            if (err) {
              console.log('上传失败', err)
            } else {
              console.log('上传成功')
              // that.form.cosKey = cosKey
              console.log(cosKey, 'cosKeycosKey')
              that.form.upUrl = cosKey
              that.isUploading = false
              // that.handleOk(cosKey)
            }
          }
        )
      })
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改设备'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
  